import { HAS_FILE_READER } from '../utils/dom';
/**
 * Asynchronously load an entire image into memory as a dataUri.
 * The result can be used as an Img src to display the image in-page.
 */

export var loadImageFileDataURL = function loadImageFileDataURL(file) {
  if (!HAS_FILE_READER) {
    throw new Error('Unable to loadImageFileDataURL in environment without FileReader');
  }

  return new Promise(function (resolve, reject) {
    var reader = new window.FileReader();

    reader.onloadend = function () {
      return resolve(reader.result);
    };

    try {
      reader.readAsDataURL(file);
    } catch (er) {
      reject();
    }
  });
};